import React from "react";
import dynamic from "next/dynamic";
import { AwardsBlock } from "../index";

// Dynamic imports
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"), { ssr: true });
const Slider = dynamic(() => import("./Slider"), { ssr: true });

interface AwardsProps {
  data: AwardsBlock;
}

const Awards: React.FC<AwardsProps> = ({ data }) => {
  return (
    <Section className="overflow-hidden">
      <div className="container">
        <div className="max-w-[948px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
          <p className="text-subtitle-2 font-regular mt-3">{data?.sub_title}</p>
        </div>
      </div>
      <div className="container !px-0">
        <div className="mt-10 min-h-[200px] md:min-h-[390px]">
          <Slider sliderData={data?.awardsLogo} />
        </div>
      </div>
    </Section>
  );
};
export default React.memo(Awards);